import React from 'react';

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {route: object, mainHeaderTitle: node, setMainHeaderTitle: () => void}>}
 */
const MainHeaderContext = React.createContext({});

export default MainHeaderContext;
